import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getThumbGlobalClassNames } from '../../helpers';
const UnknownMonoHtmlView = ({ deviation  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('daeditor-unknown', getThumbGlobalClassNames(deviation))
    }, t('deviationview.unknown.nopreview'));
};
UnknownMonoHtmlView.displayName = 'UnknownMonoHtmlView';
export default UnknownMonoHtmlView;
